import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c9c9be6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "add", -1))
const _hoisted_2 = { class: "table table-hover table-v2" }
const _hoisted_3 = { class: "border-dark border-bottom" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, " ", -1))
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  colspan: "6",
  class: "fw-bold small text-uppercase text-muted"
}
const _hoisted_12 = { class: "short-content" }
const _hoisted_13 = { class: "buttons d-flex justify-content-end align-items-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "edit", -1))
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "delete", -1))
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_base_placeholder_table = _resolveComponent("base-placeholder-table")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_BaseTitle, {
        title: _ctx.$t('teamMembers'),
        "help-text": _ctx.$t('descriptionTeamMembersOverview')
      }, {
        buttons: _withCtx(() => [
          _createElementVNode("a", {
            href: "javascript:void(0)",
            class: "btn btn-hover icon-link",
            onClick: _cache[0] || (_cache[0] = ($event: any) => {this.$router.push({name: 'new-team-member'});})
          }, [
            _hoisted_1,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('new')), 1)
          ])
        ]),
        _: 1
      }, 8, ["title", "help-text"]),
      _createElementVNode("table", _hoisted_2, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_3, [
            _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t('name')), 1),
            _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t('function')), 1),
            _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t('content')), 1),
            _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t('sortWeight')), 1),
            _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t('status')), 1),
            _hoisted_9
          ])
        ]),
        _createElementVNode("tbody", null, [
          (!_ctx.isReady)
            ? (_openBlock(), _createBlock(_component_base_placeholder_table, {
                key: 0,
                "n-cols": 5
              }))
            : (_ctx.teamMembers.length === 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                  _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.$t('noTeamMembersFound')), 1)
                ]))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.teamMembers, (teamMember) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "align-middle",
                    key: teamMember.id
                  }, [
                    _createElementVNode("td", null, _toDisplayString(teamMember.first_name) + " " + _toDisplayString(teamMember.last_name), 1),
                    _createElementVNode("td", null, _toDisplayString(teamMember.function_title), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("p", _hoisted_12, _toDisplayString(teamMember.short_content), 1)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(teamMember.sort_weight), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$t(teamMember.status_code)), 1),
                    _createElementVNode("td", _hoisted_13, [
                      _createVNode(_component_router_link, {
                        class: "btn btn-icon btn-primary ms-2",
                        to: {
                name: 'edit-team-member',
                params: {
                  id: teamMember.id
                }
              }
                      }, {
                        default: _withCtx(() => [
                          _hoisted_14
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.deleteMember(teamMember.id, teamMember.first_name, teamMember.last_name)),
                        class: "btn btn-icon btn-danger ms-2"
                      }, _hoisted_17, 8, _hoisted_15)
                    ])
                  ]))
                }), 128))
        ])
      ])
    ]),
    _: 1
  }))
}